import React from "react";
import styled from "styled-components";

export const B1Regular = styled((props) => <div {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `mmr2_button_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-family: "Roboto" !important;
  font-weight: normal !important;
  color: ${(props) => (props.color ? props.color : "#282828")} !important;
  font-size: ${(props) => (props.size ? props.size : "1em")};
  text-align: ${(props) => (props.textalign ? props.textalign : "left")};
  line-height: 1.5em;
  margin: 0 !important;
  border: none;
  background: none;
  padding: ${(props) => (props.paddingsize ? props.paddingsize : "6px")};
  width: ${(props) => (props.paddingwidth ? props.paddingwidth : "100%")};

  @media only screen and (min-width: 320px) and (max-width: 450px) {
    font-weight: 500;
    font-size: smaller;
    padding: ${(props) => (props.paddingm ? props.paddingm : "0")};
    text-align: ${(props) => (props.textalignm ? props.textalignm : "left")};
  }
`;